module.exports = __webpack_public_path__ + "img/company-logo.60b4ad31.svg";